<article class="product-tile text-center">
  <header class="padding-class">
    <h2>
      <a href="javascript:void(0)" routerLink="{{card.link}}" routerLinkActive="active" >{{ card.cardTitle }}</a>
    </h2>
  </header>
  <picture>
      <img class="show-sm" src="{{card.smallImageSrc}}" alt="{{ card.cardTitle }}" />
      <img class="hide-sm" src="{{card.imageSrc}}" alt="{{ card.cardTitle }}" />
  </picture>
  <p class="price-info">From <span class="price-month">{{card.price | currency:'USD':true:'1.2-3'}}</span><span class="month">/mo.</span></p>
  <p class="product-legal">{{card.description}}</p>
  <div class="clearfix"></div>
  <footer>
    <button role="link" class="btn btn-default learnMoreTest" *ngIf="card.activetab" routerLink="{{card.link}}" routerLinkActive="active" attr.aria-label="View {{ card.cardTitle }} details.">View</button>
    <button role="link" class="btn btn-default disabled" disabled *ngIf="!card.activetab">View</button>
  </footer>
</article>
